import SettingsLayout from './SettingsLayout';

function SettingsBillingPage() {
  return (
    <SettingsLayout>
      <div className="card">
        <div className="card-header">Billing</div>
        <p style={{ color: '#4B5563', fontSize: '1rem', marginBottom: '1.5rem' }}>
          Manage your billing information and payment methods.
        </p>
        <div style={{ padding: '2rem', backgroundColor: 'var(--color-light-grey)', borderRadius: '0.5rem', textAlign: 'center' }}>
          <p style={{ color: '#999' }}>Billing features coming soon</p>
        </div>
      </div>
    </SettingsLayout>
  );
}

export default SettingsBillingPage;
